// generated by genversion
export const version = '6.0.27';
